import { Action } from '../Action'

export const FilterActionIcon = Action.Icon
